import React from "react";
import {
  CurrencyRupeeIcon,
  XCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/outline";
import Badge from "../../../components/common/Badge";
import Button from "../../../components/common/Button";

const PaymentStatusCard = ({
  paymentStatus,
  order,
  formatCurrency,
  getPaymentColor,
  onUpdatePayment,
}) => {
  if (!paymentStatus) return null;

  const hasBlockers =
    paymentStatus.blockers && paymentStatus.blockers.length > 0;
  const hasWarnings =
    paymentStatus.warnings && paymentStatus.warnings.length > 0;

  return (
    <div className="mb-6 bg-white border-2 border-blue-200 rounded-lg p-4">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg">
            <CurrencyRupeeIcon className="w-6 h-6 text-blue-600" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">Payment Status</h3>
            <Badge variant={getPaymentColor(order.payment?.status)} size="sm">
              {order.payment?.status}
            </Badge>
          </div>
        </div>
        <Button size="sm" variant="outline" onClick={onUpdatePayment}>
          Update Payment
        </Button>
      </div>

      {/* Summary */}
      {paymentStatus.summary && (
        <p className="text-sm text-gray-700 mb-3">
          {paymentStatus.summary.statusText}
        </p>
      )}

      {/* Blockers */}
      {hasBlockers && (
        <div className="space-y-2 mb-3">
          {paymentStatus.blockers.map((blocker, idx) => (
            <div
              key={idx}
              className="bg-red-50 border border-red-200 rounded-lg p-3"
            >
              <div className="flex items-start gap-2">
                <XCircleIcon className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <p className="text-sm font-semibold text-red-900">
                    {blocker.message}
                  </p>
                  <p className="text-xs text-red-700 mt-1">{blocker.action}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Warnings */}
      {hasWarnings && (
        <div className="space-y-2">
          {paymentStatus.warnings.map((warning, idx) => (
            <div
              key={idx}
              className="bg-yellow-50 border border-yellow-200 rounded-lg p-3"
            >
              <div className="flex items-start gap-2">
                <ExclamationCircleIcon className="w-5 h-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <p className="text-sm text-yellow-900">{warning.message}</p>
                  {warning.action && (
                    <p className="text-xs text-yellow-700 mt-1">
                      {warning.action}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PaymentStatusCard;
